import client from './client';

export const uploadMedia = async (gameId, file, type) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('gameId', gameId);
  formData.append('type', type);

  const response = await client.post('/api/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteMedia = async (mediaId) => {
  const response = await client.delete(`/api/upload/${mediaId}`);
  return response.data;
};

export const getMedia = async (mediaId) => {
  const response = await client.get(`/api/upload/${mediaId}`);
  return response.data;
};
